import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import StyledLink from "../../../shared/StyledLink/StyledLink";
import "./strategy.scss";
const Strategy = () => {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    function handleScroll() {
      setOffset(window.pageYOffset);
    }

    window.addEventListener("scroll", handleScroll);
  });

  return (
    <div className="home-strategy">
      <div
        className="bg"
        style={{
          width: `${offset * 0.0065}%`,
        }}
      ></div>
      <div
        className="moon"
        style={{
          transform: `rotate(${offset * 0.075}deg)  `,
        }}
      ></div>
      <h1 className="mid-title">
        <span className="text-border">
          <FormattedMessage
            id="Strategy"
            defaultMessage="our strategy"
          />
        </span>
      </h1>
      <h1 className="big-title">
        <FormattedMessage
          id="Building"
          defaultMessage="Building products that people "
        />
        <span className="Love">
          <FormattedMessage id="Love" defaultMessage="love" />
        </span>
      </h1>
      <p className="def-text">
        <FormattedMessage
          id="Every"
          defaultMessage="Every brand that's worked with us has come out having a louder voice, more color, and more likes. We craft the visuals you'll need and love."
        />
      </p>
      <StyledLink
        to="/"
        styles="styled2"
        linkName={
          <FormattedMessage id="LearnMore" defaultMessage="Learn More" />
        }
      />
    </div>
  );
};

export default Strategy;
